import React, { ComponentProps } from 'react';

import { LoadingDots } from '../LoadingDots';

import { Button } from './Button';

import style from './TertiaryButton.scss';

import cn from 'classnames';

export function TertiaryButton({
  children,
  isLoading,
  isDisabled,
  className,
  ...props
}: ComponentProps<typeof Button>) {
  return (
    <Button
      {...props}
      className={cn(className, style.tertiary)}
      isLoading={isLoading}
      isDisabled={isDisabled}
    >
      {isLoading ? <LoadingDots variant="dark" /> : children}
    </Button>
  );
}
